<template>
  <detail
    :on-manager="onManager"
    :data="data"
    :base-info="baseInfo"
    :extra-info="extraInfo" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import {
  getReserveResourceColumn,
  getSharingModeColumn,
  getMemorySizeColumn,
  getVirtualNumColumn,
  getAllocatedCountColumn,
  getMemoryAllocatedColumn,
} from '../utils/columns'

export default {
  name: 'GpuDetail',
  mixins: [WindowsMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [
        {
          field: 'model',
          title: this.$t('compute.text_482'),
        },
        {
          field: 'dev_type',
          title: this.$t('compute.text_481'),
        },
        {
          field: 'vendor',
          title: this.$t('compute.isolated_devices.vendor.title'),
        },
        {
          field: 'vendor_device_id',
          title: this.$t('compute.isolated_devices.vendor_device_id.title'),
        },
        {
          field: 'host',
          title: this.$t('compute.text_484'),
          slots: {
            default: ({ row }) => {
              return [
                <side-page-trigger onTrigger={ () => this.handleOpenSidepage(row) } id={row.host_id}>{ row.host }</side-page-trigger>,
              ]
            },
          },
        },
        {
          field: 'guest',
          title: this.$t('compute.associated_instances'),
          formatter: function ({ row }) {
            return (row.guest || []).join(',')
          },
        },
        getReserveResourceColumn(),
        getSharingModeColumn(),
        getMemorySizeColumn(),
        {
          ...getMemoryAllocatedColumn(),
          hidden: (row) => row.sharing_mode !== 'HAMI',
        },
        {
          ...getVirtualNumColumn(),
        },
        {
          ...getAllocatedCountColumn(),
          hidden: (row) => row.sharing_mode === 'HAMI',
        },
      ],
      extraInfo: [
        {
          title: this.$t('compute.text_497'),
          items: [
            {
              field: 'addr',
              title: 'PCI_BUS_ID',
            },
          ],
        },
      ],
    }
  },
  methods: {
    handleOpenSidepage (row) {
      this.initSidePageTab('host-detail')
      this.sidePageTriggerHandle(this, 'HostSidePage', {
        id: row.host_id,
        resource: 'hosts',
        getParams: this.getParam,
      }, {
        list: this.list,
      })
    },
  },
}
</script>
